import React, { useMemo, useRef, useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { LATEST_COURSES_QUERY } from "queries/queries";
import Loading from "components/loading";
import Error from "components/error";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

const chunk3 = (arr) => {
  const out = [];
  for (let i = 0; i < arr.length; i += 3) out.push(arr.slice(i, i + 3));
  return out;
};

const NewCourses = () => {
  const { loading, error, data } = useQuery(LATEST_COURSES_QUERY, { fetchPolicy: "no-cache" });
  const history = useHistory();
  const viewportRef = useRef(null);
  const [page, setPage] = useState(0);

  const hcpLink = {
    id: "hcp-link",
    name: "HCP-Portal",
    nameShort: "HCP-Portal",
    brand: "",
    description: "",
    previewUrl: "", 
    readableDuration: "",
    locked: false,
    startDate: null,
    sections: [],
    isLink: true, 
  };

  const latestCourses = (data?.latestCourses ?? []).filter(Boolean);

  const slides = useMemo(() => {
    const merged = [hcpLink, ...latestCourses].slice(0, 9);
    return chunk3(merged);
  }, [latestCourses]);

  const total = slides.length || 1;

  const handleAllClick = () => history.push("/courses");

  // update page on scroll
  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;

    const onScroll = () => {
      const idx = Math.round(el.scrollLeft / el.clientWidth);
      setPage(Math.max(0, Math.min(idx, total - 1)));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [total]);
  
  if (loading) return <Loading />;
  if (error) return <Error />;
  if (!latestCourses.length) return <p>No courses found.</p>;

  return (
    <div className="new-courses">
      <div className="new-courses-top">
        <div>Neue Kurse</div>
        <div className="new-courses-top-links" onClick={handleAllClick}>Alle</div>
      </div>

      <div className="courses-viewport" ref={viewportRef}>
        <div className="courses-track">
          {slides.map((slide, i) => (
            <div className="courses-slide" key={i}>
              {slide.map((course) => (
                <div
                  className="course-item-container"
                  key={course.id}
                  onClick={(e) => {
                    e.preventDefault();
                    history.push(
                      course.isLink ? "/hcp-portale" : `/course_details/${course.id}`
                    );
                  }}
                >
                  {course.isLink ? (
                    <div
                      className="course-item"
                      style={{
                        backgroundColor: "#94d3f2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        aspectRatio: "1 / 1",
                      }}
                    >
                      <svg
                        viewBox="0 0 266 266"
                        xmlns="http://www.w3.org/2000/svg"
                        width="60%"  
                        height="60%"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g transform="translate(51,51) scale(0.6)">
                          <path
                            d="M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0"
                            fill="none"
                            stroke="#238CB9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="14"
                          />
                          <path
                            d="M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0"
                            fill="none"
                            stroke="#238CB9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="14"
                          />
                        </g>
                      </svg>
                    </div>

                  ) : (
                    <img className="course-item" src={course.previewUrl} />
                  )}
                  <div
                    className="course-item-title"
                    dangerouslySetInnerHTML={{ __html: course.nameShort || course.name }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="courses-progress">
        <div className="bar">
          <div className="bar-fill" style={{ width: `${((page + 1) / total) * 100}%` }} />
        </div>
      </div>
    </div>
  );
};

export default NewCourses;
